import styled from 'styled-components'

export const Container = styled.article`
	min-height: 82vh;

	form {
		background-color: #0002;
		border-radius: 10px;
		padding: 20px;
		display: grid;
		grid-template-columns: 0.5fr 1fr 1fr;
		grid-template-areas:
			'tip tip tip'
			'f1 f2 f3'
			'spinner spinner spinner'
			'button button button';
	}

	h1 {
		margin-bottom: 20px;
		grid-area: title;
		margin: 0 8px 20px;
	}

	@media(max-width: 600px) {
		form {
			margin-top: 30px;
			display: flex;
			flex-direction: column;
		}
	}

	@media(max-width: 914px) {
		display: flex;
		flex-direction: column;
	}
`
export const ButtonContainer = styled.div`
	grid-area: button;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 60px;
	margin-top: 10px;
	
	@media(max-width: 1000px) {
		button {
			width: 100%;
		}
	}

	@media(max-width: 900px) {
		flex-direction: column-reverse;
		height: unset;
		margin: 10px 8px;
		width: calc(100% - 16px);

		button {
			margin-bottom: 14px !important;
		}
	}
`
